import { get } from "lodash"
import React from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  getTimeLogByDateAction,
  moveIdHoursFromID,
  flagTimeLogInvalid,
} from "store/actions"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap"
import TimeLogTable from "./table"
import { useState } from "react"
import { InvalidFormat, StatusFormat, TimeFormat } from "./column"
import TimeLogFilter from "./filter"
import moment from "moment"
import { getUserID } from "helpers/storagehelper"
import MobileResize from "common/Resize/MobileResize"

const UserTimeLogScreen = ({}) => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}")
  const [sort, handleSort] = useState({})
  const [formData, setFormData] = useState({
    userId: authUser.data.id,
    Date: moment(new Date()).format("YYYY-MM-DD"),
  })
  const [tableStatus, setTableStatus] = useState(null)
  const dispatch = useDispatch()
  // const timeLogEntry = useSelector(state =>
  //   get(state, "workreport.timelogentry", [])
  // )

  const [selectedRow, setselectedRow] = useState({})
  const [isEdit, setIsEdit] = useState(false)
  const [statusmodal, setStatusModal] = useState(false)
  const [toSelectData, setToSelectData] = useState([])
  const [clickedRow, setClickedRow] = useState([])
  const [clickedRowToggle, setClickedRowToggle] = useState(false)
  const [flagModal, setFlagModal] = useState(false)
  const [flagRow, setFlagRow] = useState(null)
  const [flagReason, setFlagReason] = useState("")
  const [flagReasonError, setFlagReasonError] = useState(false)
  const [deviceFilter, setDeviceFilter] = useState("All")

  const isAdminUser =
    authUser?.data?.accessgroupname !== "User" &&
    authUser?.data?.accessgroupname !== "Supervisor"
  
  const { companySetting,timeLogEntry } = useSelector(state => ({
    companySetting: state?.Login?.userDetails?.data,
    timeLogEntry: state?.workreport?.timelogentry,
  }))

  const showDeviceFilter = React.useMemo(() => {
    const hasPrimary = (timeLogEntry || []).some(
      row => row?.isprimarydevice === true
    )
    const hasSecondary = (timeLogEntry || []).some(
      row => row?.isprimarydevice === false
    )
    return hasPrimary && hasSecondary
  }, [timeLogEntry])

  const filteredTimeLogEntry = React.useMemo(() => {
    if (!showDeviceFilter || deviceFilter === "All") {
      return timeLogEntry
    }
    if (deviceFilter === "Primary") {
      return (timeLogEntry || []).filter(row => row?.isprimarydevice === true)
    }
    return (timeLogEntry || []).filter(row => row?.isprimarydevice === false)
  }, [timeLogEntry, deviceFilter, showDeviceFilter])

  const dropDownDataCallback = data => {
    if (toSelectData) {
      const updatedOptions = (data?.data || []).map(el => ({
        ...el,
        value: `${el.categoryname} ${el.subCategoryName}`,
        label: `${el.categoryname} ${el.subCategoryName}`,
      }))
      setToSelectData(updatedOptions)
    }
  }

  useEffect(() => {
    setDeviceFilter("All")
    getTimeLogByDate()
  }, [formData])

  useEffect(() => { 
    const userID = {
      userid: formData?.userId,
    }
    dispatch(moveIdHoursFromID(userID, dropDownDataCallback))
  }, [formData])

  const getTimeLogByDate = () => {
    dispatch(getTimeLogByDateAction(formData))
  }

  const handleFlagClick = row => {
    setFlagRow(row)
    setFlagReason("")
    setFlagReasonError(false)
    setFlagModal(true)
  }

  const closeFlagModal = () => {
    setFlagModal(false)
    setFlagRow(null)
    setFlagReason("")
    setFlagReasonError(false)
  }

  const handleFlagConfirm = () => {
    if (!flagRow) return
    const markingInvalid = !flagRow.isinvalid
    if (markingInvalid && !flagReason.trim()) {
      setFlagReasonError(true)
      return
    }
    dispatch(
      flagTimeLogInvalid(
        {
          id: flagRow.id,
          isInvalid: markingInvalid,
          reason: markingInvalid ? flagReason.trim() : null,
        },
        () => {
          closeFlagModal()
          getTimeLogByDate()
        }
      )
    )
  }


  const columns = React.useMemo(() => {
    const result = [
      {
        Header: companySetting?.SubCategory,
        accessor: "accountName",
        disableFilters: true,
        sortDirection:
          sort.accessor === "categoryName" ? sort.direction : "none",
        Cell: row => {
          return (
            <div>
              {row?.cell?.value}
            </div>
          )
        },
        dataType: "string",
      },
      {
        Header: "Start Time",
        accessor: "starttime",
        disableFilters: true,
        sortDirection: sort.accessor === "firstname" ? sort.direction : "none",
        Cell: cellProps => {
          return <TimeFormat {...cellProps} />
        },
        dataType: "string",
      },
      {
        Header: "End Time",
        accessor: "endtime",
        disableFilters: true,
        sortDirection: sort.accessor === "lastname" ? sort.direction : "none",
        Cell: cellProps => {
          return <TimeFormat {...cellProps} />
        },
        dataType: "string",
      },
      {
        Header: "Duration",
        accessor: "duration",
        disableFilters: true,
        dataType: "string",
      },
      {
        Header: "Status",
        accessor: "activeStatusName",
        disableFilters: true,
        sortDirection:
          sort.accessor === "accessgroupname" ? sort.direction : "none",
        Cell: cellProps => {
          return <StatusFormat {...cellProps} />
        },
        dataType: "string",
      },
      {
        Header: "Previous Status",
        accessor: "previousActiveStatusName",
        disableFilters: true,
        dataType: "string",
      },
      {
        Header: "Evaluation Comments",
        accessor: "evaluationComments",
        disableFilters: true,
        dataType: "string",
      },
      {
        Header: "Valid",
        accessor: "isinvalid",
        disableFilters: true,
        Cell: cellProps => {
          return <InvalidFormat {...cellProps} />
        },
        dataType: "string",
      },
    ]
    if (isAdminUser) {
      result.push({
        Header: "Action",
        accessor: "flagAction",
        disableFilters: true,
        isDummyField: true,
        Cell: cellProps => {
          const rowData = cellProps.row.original
          return (
            <div
              role="button"
              style={{ cursor: "pointer", textAlign: "center" }}
              title={
                rowData?.isinvalid ? "Mark as valid" : "Mark as invalid"
              }
              onClick={e => {
                e.stopPropagation()
                handleFlagClick(rowData)
              }}
            >
              <i
                className={
                  rowData?.isinvalid
                    ? "mdi mdi-flag-remove text-danger"
                    : "mdi mdi-flag-outline"
                }
                style={{ fontSize: "16px" }}
              />
            </div>
          )
        },
        dataType: "string",
      })
    }
    return result
  }, [timeLogEntry])

  const handleChangeFilter = (value, key) => {
    setClickedRowToggle(false)
    if (key === "Date") {
      setFormData({ ...formData, [key]: moment(value).format("YYYY-MM-DD") })
    } else {
      setFormData({ ...formData, [key]: value.id })
    }
  }
  const columnHeaderClick = (column, pagesize, pageIndex) => {
    switch (column.sortDirection) {
      case "none":
        setSort({ direction: "Ascending", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          sortKey: column.id,
          sortValue: "Ascending",
        })
        break
      case "Ascending":
        setSort({ direction: "Descending", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          sortKey: column.id,
          sortValue: "Descending",
        })
        break
      case "Descending":
        setSort({ direction: "Ascending", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          sortKey: column.id,
          sortValue: "Ascending",
        })
        break
    }
  }
  const [isMobile, setIsMobile] = useState(window.innerWidth < 921)

  return <>
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col xs="12">
            <Breadcrumbs
              title={"View Time Log"}
              breadcrumbItem={"View timelog"}
            />
            <Card>
              <CardBody className="table-mobileView">
                <TimeLogFilter handleChange={handleChangeFilter} formData={formData} authUser={authUser}
                 tableStatus={tableStatus} setTableStatus={setTableStatus} isEdit={isEdit} toSelectData={toSelectData} clickedRow={clickedRow}
                 clickedRowToggle={clickedRowToggle} setStatusModal={setStatusModal} getTimeLogByDate={getTimeLogByDate}
                 showDeviceFilter={showDeviceFilter} deviceFilter={deviceFilter} setDeviceFilter={setDeviceFilter}
                 //handleUserEditGroup={handleUserEditGroup}
                />
                <MobileResize setIsMobile={setIsMobile}>
                <TimeLogTable data={filteredTimeLogEntry} columns={columns} columnHeaderClick={columnHeaderClick}
                tableStatus={tableStatus} setTableStatus={setTableStatus} setClickedRow={setClickedRow}
                setClickedRowToggle={setClickedRowToggle}
                clickedRowToggle={clickedRowToggle}
                isMobile={isMobile}
                //handleUserEditGroup={handleUserEditGroup}
                />
                </MobileResize>
              </CardBody>
            </Card>

          </Col>
        </Row>
        <Modal isOpen={flagModal} centered toggle={closeFlagModal}>
          <ModalHeader tag="h4" toggle={closeFlagModal}>
            {flagRow?.isinvalid ? "Mark Time Log as Valid" : "Mark Time Log as Invalid"}
          </ModalHeader>
          <ModalBody>
            {flagRow?.isinvalid ? (
              <p>
                This entry is currently marked as invalid
                {flagRow?.invalidreason ? (
                  <>
                    {" "}
                    with reason: <b>{flagRow.invalidreason}</b>
                  </>
                ) : null}
                . Do you want to mark it as valid?
              </p>
            ) : (
              <div className="mb-3">
                <label className="form-label" htmlFor="flag-invalid-reason">
                  Reason <span className="text-danger">*</span>
                </label>
                <textarea
                  id="flag-invalid-reason"
                  className={
                    flagReasonError
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  rows="3"
                  placeholder="Enter the reason for marking this entry invalid"
                  value={flagReason}
                  onChange={e => {
                    setFlagReason(e.target.value)
                    if (e.target.value.trim()) setFlagReasonError(false)
                  }}
                />
                {flagReasonError && (
                  <div className="invalid-feedback d-block">
                    Reason is required
                  </div>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color={flagRow?.isinvalid ? "success" : "danger"}
              onClick={handleFlagConfirm}
            >
              {flagRow?.isinvalid ? "Mark as Valid" : "Mark as Invalid"}
            </Button>
            <Button color="secondary" onClick={closeFlagModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  </>
}

export default UserTimeLogScreen
